import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/layout';
import Header from './components/layout/header';
import { useDarkMode } from './hooks/useDarkMode';

// Pages
import DashboardPage from './pages/dashboard/DashboardPage';
import TodoPage from './pages/dashboard/TodoPage';
import UrgentPage from './pages/dashboard/UrgentPage';
import FavoritesPage from './pages/dashboard/FavoritesPage';

import QuoteCreatePage from './pages/quote/QuoteCreatePage';
import QuoteHistoryPage from './pages/quote/QuoteHistoryPage';

import OrderManagePage from './pages/order/OrderManagePage';
import JamakePage from './pages/order/JamakePage';

import ProjectCreatePage from './pages/project/ProjectCreatePage';
import ProjectPage from './pages/work/ProjectPage';
import WorkManagePage from './pages/work/WorkManagePage';
import WorkFavoritesPage from './pages/work/WorkFavoritesPage';
import JobSettingsWizardPage from './pages/work/JobSettingsWizardPage';

import ClientManagePage from './pages/client/ClientManagePage';

import AutomationRulesPage from './pages/automation/AutomationRulesPage';
import WorkflowTemplatesPage from './pages/automation/WorkflowTemplatesPage';

import { TaskTypeManagementPage } from './pages/TaskTypeManagementPage';
import TaskTypeCreatePage from './pages/TaskTypeCreatePage';
import { WorkPresetManagementPage } from './pages/WorkPresetManagementPage';
import { PresetCreatePage } from './pages/PresetCreatePage';
import WorkerManagementPage from './pages/WorkerManagementPage';
import WorkerGroupManagementPage from './pages/WorkerGroupManagementPage';

function App() {
  // Initialize dark mode
  useDarkMode();

  return (
    <Router>
      <Layout>
        <Header />
        <Routes>
          {/* Dashboard Routes */}
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/dashboard/todo" element={<TodoPage />} />
          <Route path="/dashboard/urgent" element={<UrgentPage />} />
          <Route path="/dashboard/favorites" element={<FavoritesPage />} />

          {/* Quote Routes */}
          <Route path="/quote" element={<Navigate to="/quote/create" replace />} />
          <Route path="/quote/create" element={<QuoteCreatePage />} />
          <Route path="/quote/history" element={<QuoteHistoryPage />} />

          {/* Order Routes */}
          <Route path="/order" element={<Navigate to="/order/jamake" replace />} />
          <Route path="/order/manage" element={<OrderManagePage />} />
          <Route path="/order/jamake" element={<JamakePage />} />

          {/* Work Routes */}
          <Route path="/work" element={<Navigate to="/work/project" replace />} />
          <Route path="/work/project-create" element={<ProjectCreatePage />} />
          <Route path="/work/project" element={<ProjectPage />} />
          <Route path="/work/manage" element={<WorkManagePage />} />
          <Route path="/work/favorites" element={<WorkFavoritesPage />} />
          <Route path="/work/task-types" element={<TaskTypeManagementPage />} />
          <Route path="/work/task-types/create" element={<TaskTypeCreatePage />} />
          <Route path="/work/presets" element={<WorkPresetManagementPage />} />
          <Route path="/work/presets/create" element={<PresetCreatePage />} />
          <Route path="/work/workers" element={<WorkerManagementPage />} />
          <Route path="/work/worker-groups" element={<WorkerGroupManagementPage />} />
          <Route path="/work/job-settings/:jobId" element={<JobSettingsWizardPage />} />

          {/* Client Routes */}
          <Route path="/clients" element={<Navigate to="/clients/manage" replace />} />
          <Route path="/clients/manage" element={<ClientManagePage />} />

          {/* Automation Routes */}
          <Route path="/automation" element={<Navigate to="/automation/rules" replace />} />
          <Route path="/automation/rules" element={<AutomationRulesPage />} />
          <Route path="/automation/templates" element={<WorkflowTemplatesPage />} />


          {/* Default Route - 대시보드로 리다이렉트 */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          
          {/* 404 Route */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
